<template>
    <div class="base-input" :class="{'row': !isFloat}">
        <div v-if="!isFloat" class="col-sm-4 field-label">{{ label }}</div>
        <div class="form-group"
             :class="{'col-sm-8': !isFloat, 'form-group--centered': isCentered, 'input-group':leftAdded || rightAdded }">
            <label v-if="isFloat && label">{{ label }}<span class="base__mandatory" v-if="mandatory">*</span></label>
            <div v-if="leftAdded" class="input-group-prepend">
                <span class="input-group-text">{{leftAdded}}</span>
            </div>
            <input :type="getInputType" class="form-control" :id="id" :name="name" :value="localValue" :readonly="readonly"
                   :class="[{ 'form-control--active': isLabelFloatActive, 'is-invalid': errors && errors.has(name)}, getSizeClass, getCustomClass]"
                   v-validate="getValidators" :data-vv-as="label"
                   @input="handleInput($event.target.value)">
            <div v-if="rightAdded" class="input-group-prepend">
                <span class="input-group-text">{{rightAdded}}</span>
            </div>
            <i class="form-group__bar"></i>
            <div class="invalid-feedback">
                {{ errors && errors.first(name) }}
            </div>
        </div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'
    //import flatpickr from 'flatpickr'

    export default {
        mixins: [formElementMixin],

        props: {
            type: {default: 'text'},
            rightAdded: {type: String},
            leftAdded: {type: String}
        },

        computed: {
            getCustomClass() {
                if (this.type == 'date') {
                    return 'date-picker flatpickr-input'
                }
            },

            getInputType() {
                if (this.type == 'password') {
                    return this.type
                }

                return 'text'
            }
        },

        data() {
          return {
            localValue: this.value
          };
        },

        watch: {
          value(newVal) {
            if (newVal !== this.localValue) {
              this.localValue = newVal;
            }
          }
        },

        methods: {
          handleInput(newValue) {
            this.localValue = newValue;
            this.$emit('input', newValue);
          }
        },

        mounted() {
            /*if(this.type == 'date'){
                flatpickr('.date-picker', {
                    enableTime: true,
                })
            }*/
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/form_elements/_base.scss";</style>